import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useDropzone } from "react-dropzone";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CustomizedSnackbars from "../curriculum/CustomizedSnackbars";
// import axios from "axios";

function ImportModal({
  setOpen,
  setmainMessage,
  setMainSnackBarOpen,
  Uurl,
  Durl,
  label,
}) {
  const api = useAxiosPrivate();
  const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone();

  const [snackBarOpen, setSnackBarOpen] = React.useState(true);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });
  const handleSubmit = () => {
    let formData = new FormData();
    formData.append("file", acceptedFiles[0]);
    //axios
    //  .post("https://httpbin.org/anything", formData)
    //  .then((res) => console.log(res))
    //  .catch((err) => console.log(err));
    api
      .post(`${Uurl}`, formData)
      .then((res) => {
        setMainSnackBarOpen(true);
        setmainMessage({ message: res.data.message, type: "success" });
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        setSnackBarOpen(true);
        setMessage((prev) => {
          return {
            message: err.response.data.message,
            type: "error",
          };
        });
      });
  };

  const files = acceptedFiles.map((file) => (
    <Box
      key={file.path}
      sx={{
        //border: "0.5px solid",
        //borderColor: "secondary.lighter1",
        borderRadius: "0.6rem",
        //backgroundColor: "secondary.lighter3",
        //boxShadow: `1px 1px 2px ${}`,
        padding: "0.8rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
      }}
    >
      <InsertDriveFileIcon fontSize="medium" color="primary" />
      {file.path} - {file.size} bytes
    </Box>
  ));
  return (
    <>
      <Box sx={{ width: "30rem" }}>
        <Toolbar
          sx={{
            borderBottom: "1px solid",
            borderColor: "teritiary.lighter1",
            padding: "0px",
          }}
        >
          <Typography flexGrow={1}>Import {label}s</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Container
          className="container"
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "0.1rem",
          }}
        >
          <Box
            sx={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.3rem",
            }}
          >
            <Typography variant="span" fontSize={"0.8rem"}>
              Download the sample document before importing.
            </Typography>
            <Button
              sx={{
                width: "100%",
                //backgroundColor: "primary.lighter3",
                color: "teritiary.darker",
                display: "flex",
                justifyContent: "flex-start",
                gap: "0.5rem",
                "&:hover": {
                  //backgroundColor: "secondary.lighter3",
                },
              }}
              onClick={() => {
                console.log(Durl, Uurl);
                api
                  .get(`${Durl}`)
                  .then((res) => {
                    console.log(res);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
            >
              <Box
                flexGrow={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem",
                }}
              >
                <InsertDriveFileIcon color="teritiary.dark" fontSize="medium" />
                <Typography
                  sx={{
                    fontWeight: 400,
                    textTransform: "none",
                    lineHeight: "16px",
                    fontSize: "0.8rem",
                  }}
                >
                  Download Sample
                </Typography>
              </Box>
              <FileDownloadIcon fontSize="large" color="secondary" />
            </Button>
            <Alert
              severity="info"
              color="secondary"
              sx={{ width: "100%", background: "none" }}
            >
              Allowed types: .csv, .xlsx
            </Alert>
          </Box>
          <Box
            {...getRootProps()}
            sx={{
              padding: "30px",
              border: "2px dashed",
              borderColor: "teritiary.main",
              backgroundColor: "primary.lighter3",
            }}
          >
            <input {...getInputProps()} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloudUploadIcon
                fontSize="large"
                sx={{ color: "primary.main" }}
              />
              <Typography
                variant="subtitle"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  lineHeight: "20px",
                  textAlign: "center",
                }}
              >
                Drop you document here to start uploading
              </Typography>

              <Divider
                orientation="horizontal"
                flexItem
                sx={{
                  fontWeight: 600,
                  color: "teritiary.darker",
                  padding: "0.5rem",
                }}
              >
                OR
              </Divider>
              <Button variant="outlined" color="secondary">
                Browse
              </Button>
            </Box>
          </Box>
          <ul>{files}</ul>
          {snackBarOpen && (
            <CustomizedSnackbars
              {...{
                setSnackBarOpen,
                snackBarOpen,
                message,
                overlay: Boolean(message.type == "success"),
              }}
            />
          )}
          <DialogActions sx={{ marginTop: "1.5rem" }}>
            <Button
              variant="outlined"
              color="third"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              disabled={!Boolean(acceptedFiles[0])}
              onClick={handleSubmit}
            >
              Import
            </Button>
          </DialogActions>
        </Container>
      </Box>
    </>
  );
}

export default ImportModal;
